import { useNavigate } from "react-router-dom";
import { deactivateDemo } from "./demoApi";
import { clearDemoState } from "./demoState";
import "./demoBanner.scss";

export default function DemoBanner() {
    const navigate = useNavigate();

    const handleExit = () => {
        deactivateDemo();
        clearDemoState();
        navigate("/login", { replace: true });
    };

    return (
        <div className="demo-banner">
            <span className="demo-banner__label">Demo-Modus</span>
            <span className="demo-banner__text">Sie sehen eine Demo mit Beispieldaten. Keine echten Daten werden verwendet.</span>
            <a className="demo-banner__register" href="https://app.medinvoice.io/register" target="_blank" rel="noreferrer">Jetzt registrieren →</a>
            <button className="demo-banner__exit" onClick={handleExit}>Demo beenden</button>
        </div>
    );
}
